<div class="select-container" [id]="UniqueId">
    <div class="custom-select" [ngClass]="{'open-dropdown': OpenDropdown, 'error': Error}" (click)="toggleDropdown()">
        <div class="span-ellipsis" *ngIf="!Loading">
            <span *ngIf="TranslateKey && SelectedObject">
                {{ TranslateKey + selectedItem[KeyName[0]] | translate
                }}
            </span>
            <span *ngIf="!TranslateKey && SelectedObject">
                <div *ngIf="styleOption == StyleOptionDropdown.NORMAL">
                    {{ selectedItem ? selectedItem[KeyName[0]] : '' }}
                </div>
                <div *ngIf="styleOption == StyleOptionDropdown.ADDRESS_CENTER" class="span-nowrap">
                    <span *ngFor="let key of KeyName; let i = index" [ngClass]="{'black-text': i == 0}">
                        {{selectedItem[key]}} </span>
                </div>
            </span>
            <span [hidden]="SelectedObject" class="placeholder-select">
                {{ Placeholder }}
            </span>
        </div>
        <div class="span-ellipsis" *ngIf="Loading">
            <span class="placeholder-select ">
                {{'Loading' | translate}}
            </span>
        </div>

        <div class="chevron" [class.open]="OpenDropdown"></div>
    </div>
    <div class="options-container" [ngClass]="{'absolute': ShowAbsolute}" *ngIf="OpenDropdown">
        <div class="options-scroll">
            <div *ngFor="let option of DataArray; let last = last">
                <div (click)="selectOption(option)" [ngClass]="isSelected(option) ? 'selected-option': 'option'"
                    [attr.aria-selected]="isSelected(option)">


                    <!-- {{ TranslateKey ? (TranslateKey + option[KeyName] | translate) : option ?
                    option[KeyName] : ''}} -->
                    <div *ngIf="styleOption == StyleOptionDropdown.NORMAL">
                        <p *ngFor="let key of KeyName"> {{ TranslateKey ? (TranslateKey + option[key] | translate) :
                            option ?
                            option[key] : ''}} </p>
                    </div>

                    <div *ngIf="styleOption == StyleOptionDropdown.ADDRESS_CENTER">
                        <span *ngFor="let key of KeyName; let i = index" [ngClass]="{'black-text': i == 0}">
                            {{option[key]}} </span>
                    </div>

                    <img *ngIf="isSelected(option)" src="../../../../../../../../assets/icons/solid_check.webp"
                        alt="Check Icon" loading="lazy">
                </div>
                <div class="split-option" *ngIf="!last"></div>
            </div>
        </div>
    </div>
</div>